import { render, staticRenderFns } from "./InventoryWines.vue?vue&type=template&id=9ecf1e5e&scoped=true"
import script from "./InventoryWines.vue?vue&type=script&lang=js"
export * from "./InventoryWines.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ecf1e5e",
  null
  
)

export default component.exports